import { memo, useCallback, useContext } from 'react';

import { useLanguage } from 'assets/languages';
import Checkbox from '@components/checkbox';
import { CampaignFormFieldWrapperProps } from '../formFields.types';
import CampaignFormField from '../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import InspectionAgreementsModal from './components/inspectionAgreementsModal/inspectionAgreementsModal';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CAMPAIGN_FORM_STEP_ONE_FIELD_NAME } from '../../../campaignFormStepOne.constants';
import { useWatch } from 'react-hook-form';

const InspectionField = ({ elementIndex }: CampaignFormFieldWrapperProps) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.pages.campaigns,
  };
  const {
    modal,
    campaignFormMethods,
    brand,
    settings,
    updateCampaignId,
    checkedInspectionAgreement,
    setCheckedInspectionAgreement,
  } = useContext(CampaignFormContext);

  const [isSingleDayPosting] = useWatch({
    control: campaignFormMethods.control,
    name: [
      CAMPAIGN_FORM_STEP_ONE_FIELD_NAME.IS_SINGLE_DAY_POSTING
    ],
  });

  const changeInspectionAgreement = useCallback(() => {
    setCheckedInspectionAgreement(
      (prevCheckedInspectionAgreement) => !prevCheckedInspectionAgreement,
    );
    // 모든 날짜 초기화
    Object.values(CAMPAIGN_FORM_STEP_ONE_FIELD_NAME.PERIOD).forEach(
      (fieldName) => {
        campaignFormMethods.setValue(fieldName, null);
      },
    );
  }, []);

  const onClickCheckInspectionAgreement = async () => {
    if (updateCampaignId) {
      modal.showAlertModal({
        title: languageTexts.campaign_form_cant_be_update_modal_title,
        text: languageTexts.campaign_form_cant_be_update_modal_text,
      });
    } else {
      let couldContinue = true;
      if (!checkedInspectionAgreement) {
        couldContinue = await new Promise<boolean>((resolve) => {
          modal.showModal({
            content: () => {
              return (
                <InspectionAgreementsModal
                  brand={brand}
                  settings={settings}
                  onConfirm={() => {
                    modal.closeModal();
                    resolve(true);
                  }}
                />
              );
            },
            onRequestClose: () => {
              modal.closeModal();
              resolve(false);
            }
          });
        });
        if (!couldContinue) {
          return;
        }
        changeInspectionAgreement();

      } else {
        changeInspectionAgreement();
      }
    }
  };

  return (
    <CampaignFormField
      label={`${elementIndex}. ${languageTexts.campaign_form_inspection_field_label}`}
      description={
        updateCampaignId
          ? `${languageTexts.campaign_form_cant_be_update_modal_title} ${languageTexts.campaign_form_cant_be_update_modal_text}`
          : languageTexts.campaign_form_products_field_desc(
              brand.isCategoryFashion,
            )
      }
    >
      <div className="mt-[14px] flex flex-row items-center gap-[6px]">
        <Checkbox
          text={languageTexts.campaign_form_inspection_field_check}
          checked={checkedInspectionAgreement}
          onClick={onClickCheckInspectionAgreement}
        />
        <span className="px-[4px] py-[2px] text-white bg-black text-[12px] font-bold select-none">
          {languageTexts.recommendation}
        </span>
      </div>
      {/* {!updateCampaignId && (
        <div className="ml-[28px] md:ml-[32px] text-[12px] text-[#999]">
          {languageTexts.campaign_form_inspection_field_check_comment}
        </div>
      )} */}
    </CampaignFormField>
  );
};

export default memo(InspectionField);
